import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { TableHeader, Document } from '@/types'
import * as R from 'ramda'
import moment from 'moment'

@Component
export default class DocumentListComponent extends Vue {
  // #region data
  headers: TableHeader[] = [
    {
      text: 'Estado',
      value: 'stateCpe'
    },
    {
      text: 'Tipo',
      value: 'voucherType'
    },
    {
      text: 'Serie/Numero',
      value: 'documentNumber'
    },
    {
      text: 'Fecha Emisión',
      value: 'dateIssue'
    },
    {
      text: 'Documento Identidad',
      value: 'documentIdentity'
    },
    {
      text: 'Cliente',
      value: 'customerName'
    },
    {
      text: 'M',
      value: 'coin'
    },
    {
      text: 'Monto Grabado',
      value: 'taxedAmount',
      align: 'end'
    },
    {
      text: 'Monto Exonerado',
      value: 'exoneratedAmount',
      align: 'end'
    },
    {
      text: 'Monto IGV',
      value: 'taxAmount',
      align: 'end'
    },
    {
      text: 'Monto Total',
      value: 'totalAmount',
      align: 'end'
    },
    {
      text: 'Opciones',
      value: 'options'
    }

  ]

  footerProps:Object = {
    'items-per-page-options': [10, 50, 100]
  }
  // #endregion
  @Prop()
  items!: Document[]

  @Prop()
  isLoading!: boolean

  getCoinFormat (coin:string) {
    return R.equals(coin, 'P') ? 'S' : 'USS'
  }

  getDateIssueFormat (date: string): string {
    return moment(date.substr(0, 10)).format('DD-MM-YYYY')
  }

  getColor (state: string) {
    return R.equals(state, '0') ? 'red--text text-canceled' : ''
  }

  getStateCpeText (stateCpe:string) {
    if (stateCpe === null) {
      return 'Pendiente'
    }

    return R.equals(stateCpe, 'A') ? 'Aceptado' : 'Rechazado'
  }

  getStateCpeIcon (stateCpe:string) {
    if (stateCpe === null) {
      return 'mdi-help-circle'
    }
    return R.equals(stateCpe, 'A') ? 'mdi-check-circle' : 'mdi-close-circle'
  }

  getStateCpeIconColor (stateCpe:string) {
    if (stateCpe === null) {
      return 'amber'
    }
    return R.equals(stateCpe, 'A') ? 'green' : 'red'
  }

  @Emit()
  onDetail (item: Document) {
  }
}
